import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useCallback } from 'react';

interface ISimulationTimeProps {
  value: number;
  onChange: (n: number) => void;
  disabled?: boolean;
}

const SimulationTime = (props: ISimulationTimeProps) => {
  const onChange = useCallback(
    ({ target: { value } }: any) => props.onChange(parseInt(value)),
    [props.onChange],
  );
  return (
    <FormControl fullWidth size="small">
      <InputLabel id="time-label">Tiempo de simulación</InputLabel>
      <Select
        labelId="time-label"
        label="Tiempo de simulación"
        onChange={onChange}
        value={props.value}
      >
        <MenuItem value={30}>00:00:30</MenuItem>
        <MenuItem value={60}>00:01:00</MenuItem>
        <MenuItem value={120}>00:02:00</MenuItem>
        <MenuItem value={180}>00:03:00</MenuItem>
        <MenuItem value={300}>00:05:00</MenuItem>
        <MenuItem value={480}>00:08:00</MenuItem>
        <MenuItem value={600}>00:10:00</MenuItem>
      </Select>
    </FormControl>
  );
};

export default SimulationTime;
